import React from 'react';

import { EVENT_ENUMS } from '@vlabs/api-bindings/src/luna-client/constants';
import { useTranslation } from 'react-i18next';

import { ResultSectionPanel } from '@vlabs/pages/checks/components/result-section-panel/ResultSectionPanel';

import { ResultItem } from '../../../components/result-item/ResultItem';
import type { FaceSectionProps } from './types';
import { determinerAgeGroup } from './utils';

function FaceSection({
  value,
}: FaceSectionProps): React.JSX.Element | null {
  const { t } = useTranslation();
  const basicAttributes = value?.aggregated_estimations?.face?.basic_attributes;
  const frameEstimations = value?.frameEstimations?.estimated?.face;
  if (!basicAttributes) return null;

  return (
    <ResultSectionPanel title={t('checks:check type card.video.tags.face attributes')}>
      <ResultItem label={t('gender')}>{EVENT_ENUMS.BODY_BASIC_ATTRIBUTES.APPARENT_GENDER[basicAttributes.gender]?.label}</ResultItem>
      <ResultItem label={t('возраст.title')}>{`${determinerAgeGroup(basicAttributes.age)?.label} (${t('ageCount', { count: basicAttributes.age })})`}</ResultItem>
      <ResultItem label={t('emotion')}>{t(`emotions.${frameEstimations?.emotions?.predominant_emotion}`, { defaultValue: '-' })}</ResultItem>
      <ResultItem label={t('mask')}>{t(`mask_states.${frameEstimations?.mask?.predominant_mask}`, { defaultValue: '-' })}</ResultItem>
      <ResultItem label={t('glasses')}>{t(`glasses_states.${frameEstimations?.glasses?.glasses}`, { defaultValue: '-' })}</ResultItem>
    </ResultSectionPanel>
  );
}

export { FaceSection };
